/* @flow */

import { em } from 'polished';

import { errorColor, warningColor } from '@e180/ui/lib/token/color';
import { aaDarkGrey } from '@e180/ui/lib/token/palette';
import { subheading1FontSize } from '@e180/ui/lib/token/typography';

export default {
  root: {
    margin: [em(8, subheading1FontSize), 0],

    color: ({ accentColor }: Object) => accentColor,

    textAlign: 'center',
    textTransform: 'uppercase',
    WebkitFontSmoothing: 'antialiased',
  },
  'root-withError': {
    color: [errorColor, '!important'],
  },
  'root-withWarning': {
    color: [warningColor, '!important'],
  },
  'root-withDisabled': {
    color: [aaDarkGrey, '!important'],
  },
};
